import {API, NEW_API} from "../HttpHandler";
import config from "../../../config";

export const getStore = (storeId) => {
  return NEW_API.get(config.endPoints.stores + `/${storeId}` + `/web`);
};

export const getStoreByNodeId = (nodeId) => {
  return NEW_API.get(config.endPoints.storeByNodeId + `/${nodeId}`);
};

export const getStoreDetails = (bu, source, country) => {
  const prepareURL = `&country=${country}`;
  return NEW_API.get(
    config.endPoints.turneroStoresActive +
      `?businessUnit=${bu}&source=${source}&limit=1000&isVisible=true` +
      prepareURL
  );
};
